
import { Colors } from '../consts/Colors';

export default class Label extends Phaser.GameObjects.Container {
    constructor(scene, x, y, labelData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.img = labelData.image
        this.zoneId = labelData.zoneId;
        this.isCorrect = false
        this.zoneDroped = undefined
        this.deck = deck
        this.isGood = false

        this.labelImage = this.scene.add.image(0, 0, this.img).setOrigin(0.5);
        this.add(this.labelImage);
        this.setSize(this.labelImage.width, this.labelImage.height);


        this.badAnswerLogo = this.scene.add.image(-150, -2, 'badAnswer').setOrigin(0.5).setAlpha(0)
        this.badAnswerLogo.setScale(0.8)
        this.add(this.badAnswerLogo)

    }
    drop(pointer, gameObject, dropZone) {

        gameObject.x = dropZone.dZoneX
        gameObject.y = dropZone.dZoneY
        dropZone.onDrop()
        if (dropZone.labelDropped == undefined && gameObject.zoneDroped == undefined) {
            dropZone.labelDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true

        } else if (dropZone.labelDropped !== undefined && gameObject.zoneDroped == undefined) {
            dropZone.labelDropped.resetPosition()
            dropZone.labelDropped.zoneDroped = undefined
            dropZone.labelDropped.isDone = false
            gameObject.zoneDroped = false
            gameObject.isDone = false
            dropZone.labelDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true

        } else if (gameObject.zoneDroped !== undefined && dropZone.labelDropped == undefined) {
            gameObject.zoneDroped.labelDropped = undefined
            gameObject.zoneDroped.isDone = false
            gameObject.zoneDroped = dropZone
            dropZone.labelDropped = gameObject
            gameObject.isDone = true

        } else if (dropZone.labelDropped !== undefined && gameObject.zoneDroped !== undefined) {
            dropZone.labelDropped.x = gameObject.zoneDroped.dZoneX
            dropZone.labelDropped.y = gameObject.zoneDroped.dZoneY
            dropZone.labelDropped.zoneDroped = gameObject.zoneDroped
            dropZone.labelDropped.isDone = true
            gameObject.zoneDroped.labelDropped = dropZone.labelDropped
            dropZone.labelDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true
        }

        let nbr = this.deck.labels.filter(x => x.isDone).length
        if (nbr == this.deck.labels.length) {
            this.deck.validBtn.setUnlocked()
        } else if (nbr !== this.deck.labels.length) {
            this.deck.validBtn.setLocked()
        }
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
            if (gameObject.zoneDroped !== undefined) {
                gameObject.zoneDroped.labelDropped = undefined
                gameObject.zoneDroped.isDone = false
                gameObject.zoneDroped = undefined
            }
            let nbr = this.deck.labels.filter(x => x.isDone).length
            if (nbr == this.deck.labels.length) {
                this.deck.validBtn.setUnlocked()
            } else if (nbr !== this.deck.labels.length) {
                this.deck.validBtn.setLocked()
            }
        }
    }


    setLocked() {
        this.isDone = true
        this.disableInteractive()
    }

    resetPosition(duration) {
        this.isDone = false
        if (duration == undefined) {
            duration = 300
        }


        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
        let nbr = this.deck.labels.filter(x => x.isDone).length
        if (nbr == this.deck.labels.length) {
            this.deck.validBtn.setUnlocked()
        } else if (nbr !== this.deck.labels.length) {
            this.deck.validBtn.setLocked()
        }

    }
    setGood() {
        if (this.isGood === false) {
            this.isGood = true
            let newName = this.img.charAt(0).toUpperCase() + this.img.slice(1);
            let texture = "zone" + newName + "Full"
            this.scene.allFatZones.forEach(element => {
                if (element.zoneId == this.zoneId) {
                    element.setTexture(texture)
                }
            })


            this.scene.allZones.filter(x => x.zoneId == this.zoneId)[0].destroy()
            this.destroy()
        }
    }
    setBad() {
        this.badAnswerLogo.setAlpha(1)
    }

    reset() {
        this.resetPosition()
        this.badAnswerLogo.setAlpha(0)
        let zone = this.scene.allZones.filter(x => x.zoneId == this.zoneDroped.zoneId)[0]
        zone.reset()
        this.zoneDroped = undefined
        this.isDone = false
        this.setInteractive({ useHandCursor: true })
        
    }
}